<template>
  <div class="row g-4">
    <div
      class="col-md-6 col-lg-6 col-xl-3"
      data-wow-delay="0.2s"
      v-for="(item, index) in houseEntity"
      :key="item.publishWebId || index"
    >
      <a class="blog-item" @click="onclick(item)">
        <div class="blog-img position-relative">
          <div
            class="biz-type-badge"
            :class="Number(item.bizType) === 1 ? 'bid-badge' : 'intent-badge'"
          >
            {{ getBizTypeText(item.bizType) }}
          </div>

          <img
            :src="getCoverUrl(item)"
            class="img-fluid rounded-top w-100"
            alt=""
            style="height: 250px; object-fit: cover"
          />
        </div>

        <div class="blog-content p-3">
          <span
            class="h5 d-inline-block mb-1"
            style="
              margin-top: 2px;
              font-weight: bold;
              font-size: 18px;
              font-family: Arial;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              height: 42px;
              text-overflow: ellipsis;
            "
          >
            {{ item.projectName }}
          </span>

          <div class="blog-comment d-flex justify-content-between mb-1">
            <span
              style="
                font-size: 14px;
                font-family: Arial;
                color: #646464;
                font-weight: bold;
                margin-left: 2px;
              "
            >
              {{ item.placeTown }}
            </span>

            <span
              style="
                font-size: 14px;
                font-family: Arial;
                color: #646464;
                font-weight: bold;
              "
            >
              {{ item.rentCount || "-" }}㎡
            </span>
          </div>

          <div
            class="blog-comment row justify-content-between align-items-center"
          >
            <div class="col-md-7">
              <div class="tag-item">国企认证</div>
              <div class="tag-item" style="margin: 4px 6px">自营房源</div>
              <div class="tag-item" style="margin: 4px 0px">
                {{ getLeaseUseTypeText(item.leaseUseType) }}
              </div>
            </div>

            <div class="col-md-5 d-flex justify-content-end">
              <span
                style="
                  font-weight: bold;
                  font-size: 15px;
                  font-family: Arial;
                  color: #ff0214;
                "
              >
                {{ getPriceText(item) }}
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HouseItem",

  props: {
    houseEntity: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getBizTypeText(bizType) {
      const map = {
        1: "公开招租",
        2: "意向发布",
      };

      return map[Number(bizType)] || "项目发布";
    },

    getCoverUrl(item) {
      if (!item.coverUrl) {
        return "";
      }
      return item.coverUrl + "?x-oss-process=image/resize,l_800";
    },

    getLeaseUseTypeText(leaseUseType) {
      if (!leaseUseType) {
        return "其他";
      }

      const map = {
        1: "商业",
        2: "楼宇办公",
        8: "园区",
        16: "仓储",
        32: "厂房",
        64: "酒店",
        256: "住宅",
        512: "公寓",
        1024: "工业",
        16384: "其他",
      };

      const list = String(leaseUseType).split(",");

      return (
        list
          .map((item) => map[item])
          .filter(Boolean)
          .join(" / ") || "其他"
      );
    },

    getPriceText(item) {
      if (!item.priceMin || Number(item.priceMin) <= 0) {
        return "价格面议";
      }

      const unitText = this.getPriceUnitText(item.priceUnit);

      // 区间价格
      if (Number(item.priceType) === 2 && item.priceMax) {
        return `${this.formatMoney(item.priceMin)}-${this.formatMoney(
          item.priceMax
        )}${unitText}`;
      }

      // 固定价格
      return `${this.formatMoney(item.priceMin)}${unitText}`;
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === "") {
        return "--";
      }

      const num = Number(value);

      if (isNaN(num)) {
        return value;
      }

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    getPriceUnitText(priceUnit) {
      const map = {
        1: "元/月",
        2: "元/年",
        3: "元/㎡/天",
        4: "元/月/㎡",
      };

      return map[priceUnit] || "";
    },

    onclick(item) {
      const bizWebId = item.bizWebId;
      const bizType = item.bizType;

      const url = this.$router.resolve({
        name: "houseDetail",
        query: {
          bizWebId,
          bizType,
        },
      }).href;

      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.tag-item {
  background-color: #e8e8e8;
  color: #646464;
  display: inline-block;
  padding: 2px 5px;
  border-radius: 3px;
}

.blog-img {
  position: relative;
}

.biz-type-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.intent-badge {
  background: linear-gradient(135deg, #1677ff, #4096ff);
}

.bid-badge {
  background: linear-gradient(135deg, #e78215, #e4ae62);
}
</style>